import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';

import { AuthService } from '../../../core/services/auth.service';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { AppTopnavComponent } from '../app-topnav/app-topnav.component';

/** Shell del panel: header + barra de pestañas + nota de rol + contenido enrutado + toasts. */
@Component({
  selector: 'app-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, Toast, AppHeaderComponent, AppTopnavComponent],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent {
  protected readonly auth = inject(AuthService);
}
